import { Box, Stack, Typography, useTheme } from '@mui/material'

import libbyTalking from '~/assets/images/libby/libby-talking-right-side.webp'
import CreateOrModifyLibbyButton from '~/features/marketing/components/createOrModifyLibbyButton'
import useIsPartner from '~/features/partners/hooks/useIsPartner'
import { store } from '~/store'
import rem from '~/utils/ui'

function NoAgentAccountPortalMessage() {
  const theme = useTheme()
  const userId = store((state) => state.user.id)
  const isPartner = useIsPartner()

  return userId ? (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        flexDirection: { xxxs: 'column', md: 'row' },
        paddingLeft: isPartner ? rem(40) : 0,
      }}
    >
      {!isPartner && (
        <img
          src={libbyTalking}
          alt="Libby"
          style={{
            width: rem(150),
            height: 'auto',
          }}
        />
      )}
      <Stack spacing={1}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: theme.typography.fontWeightMedium,
          }}
        >
          You haven&apos;t created an AI Assistant for your business yet?
        </Typography>
        <Typography variant="body1">
          In order to use the account portal you need to create an AI assistant
          for your business first.
        </Typography>
        <Box>
          <CreateOrModifyLibbyButton isOnlyCreateLibby />
        </Box>
      </Stack>
    </Stack>
  ) : null
}

export default NoAgentAccountPortalMessage
